import React, { useState } from "react";
import Styles from "./emailVerificationFailed.module.scss";
import EmptyState from "../../../Shared/empty-state/emptyState";
import { linkBroken } from "../../../constants/emptyStatesVariables";
import emptyStateStyle from "../../../Shared/empty-state/emptyState.module.scss";
import { callApi } from "../../../api/fetch";
import Input from "../../../Shared/input/input";
import ErrorMessage from "../../../Shared/error-message/errorMessage";
import {
  checkIsEmpty,
  validEmail,
  isvalidEmailFirstChar,
} from "../../../utils/validation";
import Button from "../../../Shared/button/button";
import {
  primaryButtonHoverStyle,
  primaryButtonStyle,
} from "../../../Shared/buttonStyles";
import { publicEmail } from "../../../constants/publicEmail";
import Toast from "../../../Shared/toast/toast";
import { useNavigate, Link } from "react-router-dom";
import { testIdProps } from "../../../utils/testIdProps";

function EmailVerificationFailed() {
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [toggleEmailInput, setToggleEmailInput] = useState(false);
  const [error, setError] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [email, setEmail] = useState("");

  function toastTimeout(
    showToastValue: boolean,
    toastType: "success" | "error",
    toastMessage: string | string[],
    heading?: string
  ) {
    if (!showToastValue) return;

    // Show toast via react-toastify
    Toast(
      toastType,
      toastMessage,
      heading || (toastType === "success" ? "Success" : "Error")
    );
  }

  function checkEmail() {
    if (checkIsEmpty(email)) {
      setIsValidEmail(false);
      setError("Email cannot be empty");
      return false;
    }
    if (!validEmail(email)) {
      setIsValidEmail(false);
      setError("Enter a valid email");
      return false;
    }
    if (isvalidEmailFirstChar(email[0])) {
      setIsValidEmail(false);
      setError("Email cannot start with a number");
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, domain] = email.split("@");
    if (publicEmail.includes(domain.toLocaleLowerCase())) {
      setError("Only work emails are allowed");
      return false;
    }
    return true;
  }

  async function handleResendVerificationLink() {
    setLoading(true);
    try {
      await callApi("/otp/send", {
        method: "POST",
        data: {
          purpose: "signup",
          email: email,
          is_consent_provided: true,
        },
      })
        .then(() => {
          setLoading(false);
          history("/signup");
        })
        .catch((err) => {
          setLoading(false);
          toastTimeout(true, "error", (err as Error).message);
        });
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <div className={Styles.background}>
      <EmptyState type={linkBroken}>
        <div>
          <div className={"py-2"}>
            <p className={`${emptyStateStyle.emptyStateHeadingText} mb-0`}>
              Activation Link Expired
            </p>
          </div>
          <div className="py-3">
            <p className={`mb-0 ${emptyStateStyle.emptyStateBodyText}`}>
              Hi there, looks like you are late in activating your account. This
              link expires in 30 minutes.
            </p>
          </div>
          {toggleEmailInput ? (
            <div className="px-5">
              <Input
                type="email"
                name="email"
                id="email"
                autoComplete="off"
                placeholder="Enter your work email"
                labelname="Registered Email"
                hasError={error}
                isValid={isValidEmail}
                onChange={(event: any) => {
                  setEmail(event.target.value);
                  setIsValidEmail(true);
                  setError("");
                }}
                onBlur={checkEmail}
                clear={false}
              />
              {error && <ErrorMessage>{error}</ErrorMessage>}
              <div className="py-4 text-center">
                <div className="pb-2">
                  <Button
                    id="resend-link-button"
                    hoveredStyle={primaryButtonHoverStyle}
                    type="submit"
                    isLoading={loading}
                    style={primaryButtonStyle}
                    onClick={handleResendVerificationLink}
                  >
                    Resend Link
                  </Button>
                </div>
                <Link
                  {...testIdProps("sign-up-link")}
                  to="/sign-up"
                  className={`${Styles.signUpLink} px-1 mb-0 py-2`}
                >
                  Sign up
                </Link>
              </div>
            </div>
          ) : (
            <div className="py-2">
              <p className={`mb-0 ${emptyStateStyle.emptyStateBodyText}`}>
                To make a new request click{" "}
                <button
                  {...testIdProps("resend-link")}
                  className={Styles.resendEmailLink}
                  onClick={() => setToggleEmailInput(true)}
                >
                  Resend Link
                </button>
                .
              </p>
            </div>
          )}
        </div>
      </EmptyState>
    </div>
  );
}

export default EmailVerificationFailed;
